export const ENABLED = "enabled";

export const VIRTUAL_WAIITNG_ROOM_CONFIG = "virtual_waiting_room_configuration";

export const ADMITTED_EVENT = "Admitted";
export const DISABLED_EVENT = "Disabled";
export const QUEUE_STATUS_EVENT = "QueueStatus";

export const CONNECTION_ERROR_DEFAULT_MESSAGE = "Could not establish connection. Please try again later.";

export const WINDOW_UNLOAD_EVENT = "unload";

export const VWR_REFERRER = "vwr_referrer";
